/**
 * Created by Ivan on 17.05.2026
 */

Mission.TYPE_SEASON_PASS = 95;

Mission.REGISTRATIONS.set(Mission.TYPE_SEASON_PASS, () => ({
    available: cleverapps.config.availables.SEASON_PASS_MISSION,
    canStart: function () {
        const period = SeasonPassLogic.getPeriod();
        return period && bundles[`season_pass_${period}`];
    },
    eventName: "seasonpass",
    feature: "season_pass",
    oncePerEvent: true,
    semaphore: Mission.SEMAPHORE_ALWAYS,
    allLocations: true,
    name: "SeasonPass",
    logic: SeasonPassLogic,
    view: SeasonPassWindow,
    startWindow: SeasonPassStartWindow,
    finishWindow: SeasonPassFinishWindow,
    lastChanceView: SeasonPassLastChanceWindow,
    sideBarJson: (icon) => SeasonPassLogic.getSideBarJson(icon.mission.logic.period),
    tutorialScenario: SeasonPassTutorial.NAME,
    rowView: cleverapps.config.type === "merge2" ? function (row) {
        return Prefab.instantiate(bundles.season_pass_questsgroupicon_prefab.jsons.row_prefab_json, { mission: row.data.mission });
    } : undefined
}));

cleverapps.InitByFeature["season_pass"] = function () {
    cleverapps.tutorial.register(SeasonPassTutorial());
};